var render, staticRenderFns
import script from "./BpDismissable.vue?vue&type=script&lang=js&"
export * from "./BpDismissable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cdf5d1e')) {
      api.createRecord('1cdf5d1e', component.options)
    } else {
      api.reload('1cdf5d1e', component.options)
    }
    
  }
}
component.options.__file = "resources/styles/utilities/dismissable/BpDismissable.vue"
export default component.exports